import angular from "angular";

angular
	.module('app')
	.component('buhApplicationReplyForm', {
		template: require('./buh-application-reply-form.html'),
        controller: ['$http', 'moment', controller],
        bindings: {
		    application: '<',
        }
    });
    
function controller($http, moment) {
 
	let $ctrl = this;

	$ctrl.bankAccountNumber = null;
	$ctrl.date = null;
	$ctrl.documentNumber = null;
	
	$ctrl.$onInit = function () {
        $ctrl.loading = false;
        $ctrl.rejectTo = 'fin';
    };

    $ctrl.showAppCar = function (carIndex) {
        $ctrl.application.app_cars[carIndex].show = !$ctrl.application.app_cars[carIndex].show;
    }

    $ctrl.submit = function (button) {
        $ctrl.loading = true;

        $http.post('/buh/applications/' + $ctrl.application.id, {
            button: button,
            comment: $ctrl.comment,
            reject_to: $ctrl.rejectTo,
            buh_date: $ctrl.date ? moment($ctrl.date).format('YYYY-MM-DD') : null,
            document_number: $ctrl.documentNumber,
        }).then(function (response){
            $ctrl.loading = false;
            window.Swal.fire({
                icon: 'success',
                title: response.data.message,
            }).then(function () {
                window.location = '/';
            })
        }, function (error) {
            $ctrl.loading = false;
            let checked = false;
            let message = '';
            angular.forEach(error.data.errors, function (value, key){
                if (!checked) {
                    message += value[0];
                    checked = true;
                }
            });
            if (message.length) {
                window.Swal.fire({
                    icon: 'error',
                    title: message,
                })
            } else {
                alert("Не известная ошибка обратитесь к администраций сайта");
            }
        })
    }
}